// extracted by mini-css-extract-plugin
export default {"title":"SearchPage_title__j9Pv4","result":"SearchPage_result__h5-NY","searchContainer":"SearchPage_searchContainer__T6Qxl"};